<template>
    <v-row v-if="title != ''" no-gutters :class="`${classMB} title-dashboard`">
        <v-col>
            <div class="not-card-title-desk">
              <h1 class="not-card-title">
                 {{ eventId }} :: {{ titleDate }} :: {{ titleName }}{{ raceName}}
              </h1>
            </div>
            <div class="not-card-title-mob">
                <h1 class="not-card-title">{{ eventId }} :: {{ titleDate }}</h1>
                <h1 class="not-card-title">{{ titleName }}{{ raceName}}</h1>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  props: {
    classMB: { type: String, default: "mb-1"}
  },
  data () {
    return {
        options: [
            {
                type: 'eventsDetail',
                apiCall: `/api/v1/promoter/eventDetails/getEvent/`,
                components: [ 
                    'eventDetails', 'Registration', 'RegistrationSetup', 'CreateRegistrant', 
                    'ImportRegistrants', 'DeleteAllRegistrants', 'ValidateAma', 'EventClasses', 
                    'EditClasses', 'LinkedClasses', 'CreateClasses', 'ImportClasses', 'EventBrands', 
                    'ImportBrands', 'StartGrids', 'SportTags', 'RaceTimer', 'Westhold', 'MyLaps', 'WaitList',
                    'EventRaceList', 'EventRaceImages', 'EventRaceAdvanceSettings', 'Pricing', 'RegisteredSpectator',
                    'PricingOld', 'PracticeOld','RegisteredSpectatorGlobal','CloneEventsOld', 'classDivisions', 'DivisionsOld'
                ]
            },
            {
                type: 'raceDetails',
                apiCall: `/api/v1/promoter/race`,
                components: [
                  'raceDetails', 'raceEdit', 'SectionEditor', 'PhoneMonitor', 'NewParticipant', 
                  'ParticipantScores', 'DeleteClassScore', 'QuickScore', 'AddDNFParticipants', 
                  'ClearAllScores', 'ImportScoresFromRace', 'RaceClassesSetup', 'RaceScoringParameters',
                  'RaceParticipantsSetup', 'ParticipantScoresOld', 'ResultsOld', 'SectionEditorOld', 'CreateBackupRace',
                  'ScoreAnalysis'
                ]
            }
        ],
        race: null,
        raceName: '',
        promoterId: 0,
        userIdTes: 0
    };
  },
  asyncComputed: {
    data: async function () {
      const result = this.filterOption.length > 0 ? this.filterOption[0] : "";
      if(result !== "") {
          if(result.type == 'eventsDetail') {
            const id = this.$route.params.id !== undefined ? this.$route.params.id : 0;
            const response = await this.api("get", `${result.apiCall}${id}`);
            this.$emit("loadEventRace", response.message[0] !== undefined ? response.message[0] : null);
            return response.message[0] !== undefined ? response.message[0] : null;
          } else {
            const id = this.$route.params.id !== undefined ? this.$route.params.id : 0;
            const data = {raceId: id, force: true};
            const response = await this.api("post", result.apiCall, data);
            if(response.success) {
              this.race = response.message;
              const response_ = await this.api("get", `/api/v1/promoter/race/getEvent/${this.race.eventId}`);
              this.$emit("loadEventRace", response_.message[0] !== undefined ? response_.message[0] : null);
              return response_.message[0] !== undefined ? response_.message[0] : null;
            }
          }
      }
      return null;
    },
  },
  computed: {
      filterOption: function () {
          let result = this.options.filter((el1) => {
            const res = el1.components.filter((el2) => {
              return el2 === this.$route.name;
            });
            return res.length > 0;
          });
          return result;
      },
      title: function () {
        const result = this.filterOption.length > 0 ? this.filterOption[0] : "";
        if(result !== "" && this.data !== null && this.data.eventName !== undefined && this.data.eventDate !== undefined) {
            return `${this.$escapeHtml.decode(this.data.eventName)} :: ${this.data.eventDate}`;
        }
        return "";
      },
      titleName: function() {
        const result = this.filterOption.length > 0 ? this.filterOption[0] : "";
        if(result !== "" && this.data !== null && this.data.eventName !== undefined) {
            return this.$escapeHtml.decode(this.data.eventName);
        }
        return "";
      },
      eventId: function() {
        const result = this.filterOption.length > 0 ? this.filterOption[0] : "";
        if(result !== "" && this.data !== null && this.data.id !== undefined) {
            return this.data.id;
        }
        return "";
      },
      titleDate: function() {
        const result = this.filterOption.length > 0 ? this.filterOption[0] : "";
        if(result !== "" && this.data !== null && this.data.eventDate !== undefined) {
            return this.data.eventDate;
        }
        return "";
      },
      subtitle: function () {
        const result = this.filterOption.length > 0 ? this.filterOption[0] : "";
        if(result !== "" && this.data !== null && result.type === 'raceDetails') {
            return this.$escapeHtml.decode(this.race.raceName ? this.race.raceName : '');
        }
        return "";
      }
  },
  methods: {
    async getUser(){
      const response = await this.api("get", "/api/v1/users/current");
      const { message } = response;
      await this.api("get", `/api/v1/promoter/race/getEvent/${this.race.eventId}`).then(resp => {
        let _idUser = resp.message[0];
        if(message.id != _idUser.userId){
          this.$router.push("/dashBoard")
        }
      })
    }, 
  },
  async mounted () {      
    if(this.$route.name == 'ParticipantScoresOld' || this.$route.name == 'ResultsOld' || this.$route.name == 'SectionEditorOld' || this.$route.name == 'CreateBackupRace' || this.$route.name == 'ScoreAnalysis'){
      const response_ = await this.api("get", `/api/v1/promoter/race/getRaceName/${this.$route.params.id}`);
      const raceName = response_?.message?.[0]?.raceName || '';
      this.raceName = raceName ? ` :: ${this.$route.params.id} :: ${raceName}` : '';
      if(this.$route.name == 'ScoreAnalysis'){
       this.getUser();
      }  
    }
  }
}
</script>

<style scope>
.title-dashboard {background-color: var(--v-lighten-base) !important;}
.title-dashboard .not-card-title {
  color: var(--v-primary-darken2);
  font-size: 22px;
  width: max-content;
  text-align: center;
  margin: 0 auto; 
  max-width: 100%;
}
.not-card-title-mob{
  display:none;
}
@media screen and (max-width: 900px) {
  .not-card-title-desk{
      display:none;
    }
  .not-card-title-mob{
    display:inherit;
  }
}
@media screen and (max-width: 599px) {
  .title-dashboard .not-card-title {font-size: 14px;}
}
.subtitle-ti {font-size: 1rem;}
</style>